import React from 'react';
import { mockData } from '../mock';

const About = () => {
  const { aboutUs } = mockData;

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative">
        <div className="bg-gradient-to-r from-orange-400 to-yellow-400 py-10 md:py-14">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-stretch min-h-[390px]">
              <div className="lg:col-span-2 flex flex-col justify-center">
                <p className="text-orange-800 font-semibold uppercase tracking-wide mb-4">
                  ABOUT US
                </p>
                <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight">
                  {aboutUs.heroTitle}
                </h1>
              </div>
              <div className="lg:col-span-3 relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={aboutUs.heroImage}
                  alt="Corporate dining"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About Us Column */}
          <div>
            <h2 className="text-2xl font-bold mb-6" style={{color: '#73030D'}}>About Us</h2>
            <p className="text-gray-700 leading-relaxed mb-8 text-sm">
              {aboutUs.description}
            </p>
            <div className="h-80 rounded-lg overflow-hidden shadow-lg">
              <img
                src={aboutUs.approachImage}
                alt="Business handshake"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Our Approach Column */}
          <div>
            <div className="h-80 rounded-lg overflow-hidden shadow-lg mb-8">
              <img
                src="/images/about_our_approach.png"
                alt="Our approach"
                className="w-full h-full object-cover"
              />
            </div>
            <h2 className="text-2xl font-bold mb-6" style={{color: '#73030D'}}>Our Approach</h2>
            <p className="text-gray-700 leading-relaxed text-sm">
              {aboutUs.approachText}
            </p>
          </div>

          {/* Our Mission Column */}
          <div>
            <h2 className="text-2xl font-bold mb-6" style={{color: '#73030D'}}>
              {aboutUs.missionTitle}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-8 text-sm">
              {aboutUs.missionText}
            </p>
            <div className="h-80 rounded-lg overflow-hidden shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjb29raW5nfGVufDB8fHx8MTc1OTIyNTEyMnww&ixlib=rb-4.1.0&q=85"
                alt="Professional cooking"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;